import {User} from "@irati/types"

import {Basket} from "../types"

export const isShareableWithTeams = (user: User, recipientsOrBasket: User[] | Basket = []): boolean => {
  // cover legacy until native will update to pass the recipients array without the wrapper
  let recipients = recipientsOrBasket
  if (!Array.isArray(recipientsOrBasket)) {
    recipients = recipientsOrBasket.recipients
  }
  const ids = shareableWithTeamsIds(user, recipients)
  return ids.length > 0
}

export const shareableWithTeamsIds = (user: User, recipientsOrBasket: User[] | Basket = []) => {
  let recipients = recipientsOrBasket
  if (!Array.isArray(recipientsOrBasket)) {
    recipients = recipientsOrBasket.recipients
  }
  const {teamIds: userTeams = []} = user

  const recipientsTeams = recipients
    .map((recipient) => recipient.teams)
    .filter((teams) => teams)
    .reduce((carry: string[], teams) => {
      // The native user -> teams already come back as an array of teamId's
      // from the user picker so there is no need to map over and get the uuid
      if (teams && teams.results) {
        return [...carry, ...teams.results.map(({uuid}) => uuid)]
      }
      return [...carry, ...teams]
    }, [])

  const teamIds: string[] = []
  recipientsTeams.map((teamId) => teamIds.push(teamId))
  userTeams.map((teamId) => teamIds.push(teamId))

  return teamIds
}
